$(document).ready(function() {
    $('#payment-country-select').keyup(function() {
        $('.payment-country').each(function() {
            $(this).hide();
        });

        $('.preview-area').each(function() {
            $(this).hide();
        });

        $('#payment-country-' + codeCountry()).show();

        let isCountrySelected = false;

        $('.payment-country').each(function() {
            if ($(this).css('display') === 'block') {
                isCountrySelected = true;
            }
        });

        if (isCountrySelected === false) {
            $('.default-payment-country').show();
        }
    });

    $('#payment-country-select').click(function() {
        $(this).select();
    });

    $('.copy-code-button').click(function() {
        $('#code-' + codeCountry()).select();

        document.execCommand('copy');
    });

    $('.preview-code-button').click(function() {
        $('#preview-' + codeCountry()).show();
    });

    let codeCountry = function() {
        return $('#payment-country-select').val().split('(').pop().split(')')[0];
    }
});
